import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SongListPage from "@/pages/SongListPage";
import SongPage from "@/pages/SongPage";
import { SongProvider } from "@/context/SongContext";
import "@/App.css";

function App() {
    return (
        <SongProvider>
            <BrowserRouter>
                <div className="min-h-screen bg-background">
                    <Routes>
                        <Route path="/" element={<SongListPage />} />
                        <Route path="/song/:songId" element={<SongPage />} />
                    </Routes>
                    <Toaster position="bottom-center" richColors />
                </div>
            </BrowserRouter>
        </SongProvider>
    );
}

export default App;